import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Radio } from '../Radio/Radio.web.js';
import { useDisabledCallback } from '../utils/hooks/useDisabledCallback.js';
import { Gap } from '../Gap/Gap.web.js';
import { ContentText } from '../ContentText/ContentText.web.js';
import { useSmartControlledEventHandler } from '../utils/hooks/useSmartControlledEventHandler.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { spacing } from '../constants/spacing.js';

var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      color = _ref.color,
      wrapperStyle = _ref.wrapperStyle,
      name = _ref.name,
      disabled = _ref.disabled,
      items = _ref.items,
      radioButtonStyle = _ref.radioButtonStyle,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly,
      valueProp = _ref.value,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? spacing.xxs : _ref$size,
      id = _ref.id,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["required", "color", "wrapperStyle", "name", "disabled", "items", "radioButtonStyle", "onChange", "readOnly", "value", "size", "id", "label"]);

  var _useSmartControlledEv = useSmartControlledEventHandler('', valueProp, onChange),
      _useSmartControlledEv2 = _slicedToArray(_useSmartControlledEv, 2),
      value = _useSmartControlledEv2[0],
      handleInputChange = _useSmartControlledEv2[1];

  var disabledHandleInputChange = useDisabledCallback(handleInputChange, Boolean(readOnly || disabled));
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Gap, _extends({
    "data-test": "elemental-RadioButtonGroup",
    style: wrapperStyle,
    size: size,
    flexDirection: "column",
    role: "radiogroup",
    "aria-labelledby": "elemental-RadioButtonGroup-".concat(id || name, "__label")
  }, props), label && /*#__PURE__*/React.createElement(ContentText, {
    size: "l",
    weight: "medium",
    id: "elemental-RadioButtonGroup-".concat(id || name, "__label")
  }, label), items.map(function (_ref2) {
    var itemProps = _extends({}, _ref2);

    return /*#__PURE__*/React.createElement(Radio, _extends({
      required: required,
      key: itemProps.value,
      checked: value === itemProps.value,
      disabled: disabled,
      name: name,
      onChange: disabledHandleInputChange,
      style: radioButtonStyle,
      readOnly: readOnly,
      color: color ? color : theme.colors.primary
    }, itemProps));
  }));
};

export { RadioButtonGroup };
